import React, { useContext, useEffect, useState } from "react";
import AlertContext from "../../Context/Alert/AlertContext";
import { BaseURL } from "../../Files/BaseURL";
import axios from "axios";

const Error = () => {
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [isDeclined, setIsDeclined] = useState(false);

  const alertContext = useContext(AlertContext);
  const { showAlert } = alertContext;

  const fetchDeclineMessage = async () => {
    try {
      setIsLoading(true);
      const authToken = localStorage.getItem("p@token");
      const response = await axios.get(
        `${BaseURL}/api/decline/declinemessage`,
        {
          headers: {
            "Content-Type": "application/json",
            "auth-token": authToken,
          },
        }
      );

      if (response.data) {
        setMessage(response.data.message);
        setIsDeclined(true);
      } else {
        showAlert("No pending documents found", "info");
      }
    } catch (error) {
      console.error("Error fetching decline message:", error);
      showAlert(
        error.response?.data?.message || "Error fetching status",
        "danger"
      );
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchDeclineMessage();
  }, []);

  const handleSupportClick = () => {
    window.open("https://help-center.paycott.de/login", "_blank");
  };

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-primarygreen"></div>
      </div>
    );
  }

  return (
    <div className="flex flex-col justify-center items-center my-20">
      <div
        className={`rounded-xl flex flex-col gap-4 justify-center items-center py-10 px-10
          ${isDeclined ? "bg-red-500" : "bg-white"}`}
      >
        <div className="bg-gray-200 rounded-full p-8">
          <img
            src="../Assets/Prop/Lock.png"
            alt="Lock Icon"
            className="w-16 h-16 object-contain"
          />
        </div>

        <p className="font-pop text-gray-600 text-center max-w-md">
          After careful review of your application, we regret to inform you that
          we cannot support your account at this time.
        </p>

        {message && (
          <p className="font-pop text-gray-600 text-center max-w-md">
            Reason: {message}
          </p>
        )}

        <button
          onClick={handleSupportClick}
          className="font-pop text-primarygreen hover:underline text-center transition-colors duration-200 ease-in-out hover:text-green-700 focus:outline-none"
        >
          Contact Support
        </button>
      </div>
    </div>
  );
};

export default Error;
